import { redirect, RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { DDE_MENU_ICONS } from '@/router/icons'
import OperatorsView from '@/views/Operators'
import OperatorView from '@/views/Operators/Operator'
import LicensesView from '@/views/Operators/Operator/Licenses'
import UsersView from '@/views/Operators/Operator/Users'

export const operatorsRoutes: RouteObject[] = [
  {
    path: 'operators',
    label: 'Operators',
    platforms: [PLATFORM.DDE],
    icon: DDE_MENU_ICONS.OPERATORS,
    children: [
      {
        index: true,
        element: <OperatorsView />,
        platforms: [PLATFORM.DDE]
      },
      {
        path: ':operatorId/*',
        element: <OperatorView />,
        children: [
          {
            index: true,
            loader: () => redirect('licenses'),
            platforms: [PLATFORM.DDE]
          },
          {
            path: 'licenses',
            element: <LicensesView />,
            platforms: [PLATFORM.DDE]
          },
          {
            path: 'users',
            element: <UsersView />,
            platforms: [PLATFORM.DDE]
          }
        ]
      }
    ]
  }
]
